import React from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber } from "../../../../helpers/formatting";
import { LinkText } from '../../index';
import './phone_link.scss';

export const PhoneLink = ({
    disabled = false,
    iconProps, // overrides default phone icon size and color
    phone,
    onClick = () => { }
}) => {

    const phoneNumber = phone ? formatPhoneNumber(phone) : '';
    const linkProps = phoneNumber
        ? {
            href: `tel:${phoneNumber}`,
            onClick: onClick,
            typographyProps: {
                type: 'body-01',
            }
        }
        : {
            noRoute: true, // Disable hover/cursor style and not clickable
            typographyProps: {
                type: 'heading-01',
                color: '$color-secondary-a2'
            }
        };

    return (
        <LinkText
            {...linkProps}
            disabled={disabled}
            decorator="mobile"
            icon="phone"
            iconProps={{
                color: iconProps?.color || "$color-primary-a3",
                size: iconProps?.size || "medium"
            }}
        >
            <div className="mybswh-phone-link">
                {phoneNumber
                    ? <>
                        {phoneNumber}
                    </>
                    : <>
                        -
                    </>
                }
            </div>
        </LinkText>
    )
}

PhoneLink.propTypes = {
    disabled: PropTypes.bool,
    iconProps: PropTypes.object,
    phone: PropTypes.string,
    onClick: PropTypes.func,
};
